import {
  AuthorizationState,
  useAuthorizationState
} from '@dtx-company/inter-app/src/hooks/auth/useAuthorizationState'
import { UNAUTHORIZED_PRINT_STORE_FALLBACK_LINK } from '../constants/store'

export const useStoreAuthorizationState = (): AuthorizationState => {
  return useAuthorizationState({
    unauthorizedRedirectTo: UNAUTHORIZED_PRINT_STORE_FALLBACK_LINK,
    nameOfAuthorizedOrg: 'Flowcode',
    authorizedOperation: 'view:print_store',
    isExternalRedirect: true
  })
}
